export enum WithdrawalTicketStatus {
  Pending = 1,
  Approved = 2,
  InProgress = 3,
  Done = 200,
  Rejected = 998,
  Cancelled = 999,
}
